import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { cloneDeep, find } from 'lodash';
import { TextField } from 'new/elements/TextField';
import { completeTxBuilderRecipeGroups } from 'js/lib/RecipeBuilderUtils';
import EditTextIcon from 'js/components/elements/icons/EditTextIcon';
import { RECIPE_GROUP_ANNOTATIONS, SchemaBrowserType } from 'js/constants/schemaEditor';
import TransformsUtils from 'js/lib/TransformsUtils';

import { updateSchemaAnnotations } from 'js/actions';

const getAnnotationsGroup = (recipeGroups, attr) => {
  return find(
    recipeGroups,
    ({ type, data }) => type === RECIPE_GROUP_ANNOTATIONS && find(data, { attr: attr.__name }),
  );
};

const AttributeDescriptionEditor = ({
  gridId,
  dataSet,
  attr,
  // from redux
  transforms,
  recipeGroups,
  updateSchemaAnnotations,
}) => {
  const [description, setDescription] = useState(attr?.__description || '');

  useEffect(() => {
    setDescription(attr?.__description || '');
  }, [attr]);

  const _handleDescriptionChanged = (event) => {
    const { value } = event.target;
    if (value === description) return;
    setDescription(value);
  };

  const onBlurPersist = () => {
    // find the first annotation recipe group containing an annotation for this attr
    const newRecipeGroups = cloneDeep(recipeGroups);

    let annotationsGroup = getAnnotationsGroup(newRecipeGroups, attr);

    // if none found, find the first annotation recipe group
    if (!annotationsGroup) {
      annotationsGroup = find(newRecipeGroups, {
        type: RECIPE_GROUP_ANNOTATIONS,
      });
    }

    // if none found, create one
    if (!annotationsGroup) {
      annotationsGroup = {
        type: RECIPE_GROUP_ANNOTATIONS,
        data: [],
      };

      newRecipeGroups.push(annotationsGroup);
    }

    // in this recipe group, find the annotation for this attr
    let recipe = find(annotationsGroup.data, { attr: attr.__name });

    // if none found, create one
    if (!recipe) {
      recipe = {
        attr: attr.__name,
        description: null,
      };
      annotationsGroup.data.push(recipe);
    }

    // update description in the recipe
    if (description) {
      recipe.description = description;
    } else {
      annotationsGroup.data.splice(annotationsGroup.data.indexOf(recipe));
    }

    const { saObject } = TransformsUtils.getTxFromRecipe(newRecipeGroups);

    updateSchemaAnnotations(dataSet.id, saObject, {
      v: 2,
      spec: completeTxBuilderRecipeGroups(newRecipeGroups, transforms),
    });
  };

  return dataSet && gridId === SchemaBrowserType.OUTPUT ? (
    <div className="attribute-description-editor">
      <EditTextIcon width={22} />
      <TextField
        multiline
        fullWidth
        value={description}
        placeholder="Add description..."
        onBlur={onBlurPersist}
        onChange={_handleDescriptionChanged}
      />
    </div>
  ) : (
    <p className="attribute-description-editor">{description}</p>
  );
};

const mapStateToProps = (state) => {
  const {
    entities: { transforms },
    recipeBuilder: { recipeGroups },
  } = state;

  return {
    transforms,
    recipeGroups,
  };
};

export default connect(mapStateToProps, {
  updateSchemaAnnotations,
})(AttributeDescriptionEditor);
